const CheckIcon = () => (
  <svg  className='icon check-icon' version="1.1" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 64 64">
    <title>EP-CHECK</title>
    <path d="M31.936 1.28c-16.934 0-30.656 13.722-30.656 30.656s13.722 30.656 30.656 30.656 30.656-13.722 30.656-30.656-13.722-30.656-30.656-30.656zM49.446 22.694l-21.747 21.709c-0.448 0.448-1.024 0.666-1.6 0.666s-1.165-0.218-1.6-0.666l-10.061-10.048c-0.883-0.883-0.883-2.33 0-3.213s2.33-0.883 3.213 0l8.461 8.448 20.134-20.109c0.883-0.883 2.33-0.883 3.213 0 0.87 0.883 0.87 2.317-0.013 3.213z"></path>
  </svg>
)

export default CheckIcon
